import { Injectable } from '@angular/core';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private readonly defaultDuration = 5000;

  constructor(private _snackBar: MatSnackBar) { }

  openSnackBar(message: string, snackbarType: string, duration?: number) {
    this.openSnackBarInternal(message, snackbarType);
  }

  openSnackBarWithCloseButton(
    message: string,
    snackbarType: string,
    duration?: number,
    onCloseCallback?: () => void) {
    this.openSnackBarInternal(message, snackbarType, onCloseCallback);
  }

  private openSnackBarInternal(
    message: string,
    snackbarType: string,
    onCloseCallback?: () => void) {
    const resolvedType = this.resolveSnackbarType(snackbarType);
    const isPersistentSnackbar = this.isPersistentSnackbar(resolvedType);
    const resolvedDuration = this.getDefaultDuration(resolvedType);
    const actionLabel = 'x';
    const panelClasses = [resolvedType, 'snackbar-with-close'];

    if (isPersistentSnackbar) {
      panelClasses.push('snackbar-error');
    }

    const snackBarRef = this._snackBar.open(message, actionLabel, {
      duration: resolvedDuration,
      verticalPosition: 'top',
      panelClass: panelClasses,
    });

    snackBarRef.onAction().subscribe(() => {
      if (onCloseCallback) {
        onCloseCallback();
      }

      snackBarRef.dismiss();
    });
  }

  private getDefaultDuration(snackbarType: string): number | undefined {
    if (this.isPersistentSnackbar(snackbarType)) {
      return 10000; // 10 seconds for persistent snackbars
    }

    return this.defaultDuration;
  }

  private isPersistentSnackbar(snackbarType: string): boolean {
    const normalizedType = snackbarType.trim().toLowerCase();

    return normalizedType === 'danger'
      || normalizedType === 'btn-danger'
      || normalizedType === 'warning'
      || normalizedType === 'btn-warning';
  }

  private resolveSnackbarType(snackbarType: string): string {
    const normalizedType = snackbarType.trim().toLowerCase();

    if (normalizedType === 'error') {
      return 'danger';
    }

    return snackbarType;
  }
}
